import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import WelcomeImage from '../../Components/ImagesWithElements/WelcomeImage';
import PasswordInput from '../../Components/PasswordInput';
import usePortalService from '../../services/PortalService';
import { Spin } from 'antd';

type LoginProps = {
    setToken: (token: string) => void;
    setRole: (role: string) => void;
}

export default function Login({ setToken, setRole } : LoginProps) {
    const { login, getAvatar, getCompanyImage } = usePortalService();
    const navigate = useNavigate();

    const regEmail = /[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+/;
    const [email, setEmail] = useState('');
    const [emailDirty, setEmailDirty] = useState(false);
    const [emailError, setEmailError] = useState('Некорректный email');

    const [password, setPassword] = useState('');
    const [passwordDirty, setPasswordDirty] = useState(false);
    const [passwordError, setPasswordError] = useState('Некорректный пароль');

    const [authError, setAuthError] = useState('');
    const [sended, setSended] = useState(false);

    const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        switch (e.target.name) {
            case 'email':
                setEmailDirty(true)
                break;
            case 'password':
                setPasswordDirty(true)
                break;
        }
    }

    const emailHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
        if (!regEmail.test(String(e.target.value).toLowerCase())) {
            setEmailError('Некорректный email')
        } else {
            setEmailError('')
        }
    }

    const passwordHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value)
        if (e.target.value.length < 1) {
            setPasswordError('Введите пароль')
        } else {
            setPasswordError('')
        }
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (emailError || passwordError) {
            setEmailDirty(true)
            setPasswordDirty(true)
        } else {
            setSended(true)
            setAuthError('')
            const result = await login({
                login: email,
                password
            });
    
            if (result.success) {
                setToken(result.token);
                setRole(result.role);
                if (result.iconProfile) {
                    let icon;
                    if (result.role === "manager") {
                        icon = await getCompanyImage(result.iconProfile)
                    } else {
                        icon = await getAvatar(result.iconProfile)
                    }
                    localStorage.setItem('iconProfile', icon);
                }
                if (result.isRedirectToMainPage) {
                    navigate(0);
                } else {
                    const tours = []
                    if (result.role === "manager") {
                        tours.push('homeEmployer', 'vacancyEditor', 'candidates')
                    }
                    else if (result.role === "profile") {
                        tours.push('vacancies', 'vacancy')
                    }
                    localStorage.setItem('incompleteTours', JSON.stringify(tours));
                    navigate('/fillProfile1');
                    navigate(0);
                }
            } else {
                setSended(false)
                setAuthError(result.errors)
            }
        }
    }

    return (
        <>
            <div className="main-container">
                <section className="auth-sidebar d-none d-md-block">
                    <WelcomeImage/>
                </section>
                <div className="content" >
                    <div className="auth-content">
                        <h1 style={{ marginBottom: '32px' }}> Войти в РТСИМ.Карьера </h1>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="form-group" controlId="formEmail">
                                <Form.Label> Email </Form.Label>
                                <Form.Control 
                                    type="email" 
                                    placeholder="" 
                                    name='email'
                                    value={email} 
                                    onBlur={(e: React.FocusEvent<HTMLInputElement>) => blurHandler(e)}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => emailHandler(e)}
                                    isInvalid={!!(emailDirty && emailError)} 
                                />
                                {(emailDirty && emailError) && <p className="error-alert">{emailError}</p>}
                            </Form.Group>
                            <Form.Group className="form-group" controlId="formPassword">
                                <div className="pair-input">
                                <Form.Label> Пароль </Form.Label>
                                <a className="forgot-password" href='/forgotPassword'> Забыли пароль? </a>
                                </div>
                                <PasswordInput 
                                    value={password} 
                                    onChange={e => passwordHandler(e)} 
                                    onBlur={e => blurHandler(e)} 
                                    name="password"
                                    isInvalid={!!(passwordDirty && passwordError)}
                                />
                                {(passwordDirty && passwordError) && <p className="error-alert">{passwordError}</p>}
                            </Form.Group>
                            <br />
                            {(sended) ? 
                                <Spin tip="Загрузка">
                                    <div className="content" />
                                </Spin> :
                                <Button variant="primary" type="submit" style={{width: '173px', height: '40px'}}> Войти </Button>
                            }
                            <p className="error-alert">{authError}</p>
                            <p style={{ marginTop: '40px' }}> Посмотрите <a href='/vacancies'> Вакансии </a> и <a href='/candidates'> Кандидатов </a> без регистрации. </p>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
};